/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-06-17 14:05:34
 * @LastEditors: zhaoshuai11
 * @LastEditTime: 2025-12-02 14:35:59
 * @FilePath: \layout\src\utils\apolloConfig.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/*
 * @Description: 配置请求类
 */

// import { Message } from 'hui';
import configApi from '@/components/business/intelligentAssistant/api/modules/config.ts';
// import { parseDataValue } from '@/utils/apollo';
export default class config {
  constructor() {
    // 对应所有命名空间的配置
    this.ABILITY = {};
    this.TRAINING = {};
    this.requestComplete = this.init();
    // 初始化获取配置
  }

  /**
   * 配置信息初始化方法
   * @param {*}
  //  * @returns {*}
  //  */
  init() {
    return new Promise(resolve => {
      const ABILITY = this.getConfigCenterData({
        clusterName: 'intelligent',
        namespaceName: 'ability'
      })
        .then(res => {
          this.ABILITY = res;
        })
        .catch(error => {
          console.log(error);
        });

      const TRAINING = this.getConfigCenterData({
        clusterName: 'intelligent',
        namespaceName: 'training'
      })
        .then(res => {
          this.TRAINING = res;
        })
        .catch(error => {
          console.log(error);
        });

      Promise.allSettled([ABILITY, TRAINING]).then(() => {
        resolve(true);
      });
    });
  }



  /**
   * 请求配置中心数据
   * @param {String} appId 应用Id
   * @param {String} clusterName 集群名
   * @param {String} namespaceName 命名空间
   * @returns {*}
   */
  getConfigCenterData({ appId = 'aiop-console', clusterName, namespaceName }) {
    return new Promise(resolve => {
      let sendHttpCount = 0;
      const maxRetries = 3;
      const fetchConfig = async () => {
        try {
          const result = await configApi.getConfig({ appId, clusterName, namespaceName });
          if (result.status === 200) {
            const { data } = result;
            resolve(data);
          } else {
            throw new Error('Request failed');
          }
        } catch (error) {
          sendHttpCount++;
          if (sendHttpCount < maxRetries) {
            // eslint-disable-next-line no-undef
            setTimeout(fetchConfig, 1000);
          } else {
            resolve({});
          }
        }
      };

      fetchConfig();
    });
  }
}
